export default __webpack_public_path__ + "static/media/screenshot1.3b2f75c2.jpg";